import mapActions from './mapActions';

export default mapActions('room_types');
